import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        whenMatching: String,
    }

    submit(event) {
        clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
            this.element.requestSubmit() // works with Turbo
        }, 300) // debounce delay in ms
    }
}
